"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.safeEval = void 0;
function safeEval(method) {
    if (typeof method !== 'string') {
        return method;
    }
    var final;
    try {
        // tslint:disable-next-line:no-eval
        final = eval(method);
    }
    catch (e) { }
    return final;
}
exports.safeEval = safeEval;
